module.exports = __webpack_public_path__ + "static/media/poster-overlay.99b90a81.png";